/**
 * @readonly
 * @enum {string}
 */
export default Object.freeze({
  StripeExpressTest: 'StripeExpressTest',
  StripeExpress: 'StripeExpress',
})
